export default __webpack_public_path__ + "img/6f190e4142f39e02c0e1f58eae05eb15.png";